// ActionCable
import * as Cable from "@rails/actioncable"
window.Cable = Cable
window.App ??= {}
App.cable = Cable.createConsumer()
